import { pathgen } from 'object-path-generator';
import { overrideTestIds } from "../../utils/TestIds/overrideTestIds";
export const TextButtonTestIds = pathgen('TextButtonTestIds', overrideTestIds({
  TextButtonTestIds: {
    Wrapper: testid => testid ? "".concat(testid, "-wrapper") : undefined,
    Tooltip: testid => testid ? "".concat(testid, "-tooltip") : undefined
  }
}));